<p-toast></p-toast>

<form [formGroup]="productForm" (ngSubmit)="saveProduct()">
  <div class="top-main-wrapper">
    <div class="dash-header">
      <div class="dash-title">
        <div class="p-field p-grid">
          <div class="p-col-7 p-md-7">
            <h3>{{ pageTitle }}</h3>
          </div>
          <div class="p-col-5 p-md-5">
            <button
              pButton
              pRipple
              icon="pi pi-save"
              label="Salva"
              class="p-button p-button-success p-mr-2 pull-right"
              [disabled]="saving || productForm.invalid"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-inner">
    <p *ngIf="loading">Caricamento...</p>
    <p *ngIf="error">{{ error }}</p>

    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Informazioni</p-tab>
        <p-tab value="1">Seo</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="p-grid product-edit-grid">
            <div class="p-col-12 p-md-8">
              <p-card>
                <div class="p-fluid">
                  <div class="p-field p-grid">
                    <label class="p-col-12">Titolo <span class="required">*</span></label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="title" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Page title</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="page_title" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Page url</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="page_url" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Descrizione</label>
                    <div class="p-col-12">
                      <textarea pTextarea rows="4" formControlName="description"></textarea>
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Descrizione 1</label>
                    <div class="p-col-12">
                      <textarea pTextarea rows="4" formControlName="description_1"></textarea>
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Descrizione 2</label>
                    <div class="p-col-12">
                      <textarea pTextarea rows="4" formControlName="description_2"></textarea>
                    </div>
                  </div>
                </div>
              </p-card>
            </div>

            <div class="p-col-12 p-md-4 product-rental-setup">
              <p-card>
                <div class="p-fluid">
                  <div class="p-grid p-mb-3">
                    <div class="p-col-12 p-md-6">
                      <label class="p-col-12 p-mb-2">Attivo</label>
                      <p-selectButton
                        [options]="stateOptions"
                        formControlName="is_active"
                        optionLabel="label"
                        optionValue="value"
                      ></p-selectButton>
                    </div>

                    <div class="p-col-12 p-md-6">
                      <label class="p-col-12 p-mb-2">Featured</label>
                      <p-selectButton
                        [options]="stateOptions"
                        formControlName="is_featured"
                        optionLabel="label"
                        optionValue="value"
                      ></p-selectButton>
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Status</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="status" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Categoria</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="category_id" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Work</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="works_id" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Location</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="location_id" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">Employee</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="employee_id" />
                    </div>
                  </div>
                </div>
              </p-card>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <div class="p-grid product-edit-grid">
            <div class="p-col-12">
              <p-card>
                <div class="p-fluid">
                  <div class="p-field p-grid">
                    <label class="p-col-12">SEO title</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="page_seotitle" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">SEO keywords</label>
                    <div class="p-col-12">
                      <input type="text" pInputText formControlName="page_seokeywords" />
                    </div>
                  </div>

                  <div class="p-field p-grid">
                    <label class="p-col-12">SEO description</label>
                    <div class="p-col-12">
                      <textarea
                        pTextarea
                        rows="4"
                        formControlName="page_seodescription"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </p-card>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</form>
